import { ListTheme } from '@/components/List/theme';
import { GenericSlotFactory } from 'base/components/GenericSlot';

const $ = GenericSlotFactory({ theme: ListTheme });

const Base = $({ as: 'ul' });
const Item = $({ as: 'li', slot: 'item' });

export const List = Object.assign(Base, { Item });
